import { render, staticRenderFns } from "./textInfo.vue?vue&type=template&id=294cedbd&scoped=true"
import script from "./textInfo.vue?vue&type=script&lang=js"
export * from "./textInfo.vue?vue&type=script&lang=js"
import style0 from "./textInfo.vue?vue&type=style&index=0&id=294cedbd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294cedbd",
  null
  
)

export default component.exports